module.exports = __webpack_public_path__ + "static/media/r-md7.197589b1.png";